/* Load Modules */
import { memoize } from "lodash";

/* Load Components */
import { FormBox } from "../../../../../../../utils/forms/components/FormBoxes";

/* Load Constants */
import * as MAIL_SENDER_CONSTS from "./MailSenderConfiguratinSection.constants";
import buildFormGridFields from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../utils/forms/builders/build-schema-compliant-definition";

export const mailSenderConfigBox = ({ schema, mailConfig }): FormBox[] => {
    const mailSenderFormDefinition =
        MAIL_SENDER_CONSTS.MAIL_SENDER_FORM_DEFINITION();

    let schemaDefinitions = { ...schema } || {};
    if (mailConfig != null && mailConfig.enabled) {
        let requiredKeys = Object.keys(schemaDefinitions.properties);
        if (!requiredKeys.includes("enabled")) {
            if (requiredKeys.includes("use_tls")) {
                const index = requiredKeys.indexOf("use_tls");
                if (index > -1) {
                    requiredKeys.splice(index, 1);
                }
            }

            schemaDefinitions.required = requiredKeys;
        }
    } else if (
        schemaDefinitions.hasOwnProperty("required") &&
        schemaDefinitions.required.length > 0
    ) {
        schemaDefinitions.required = [];
    }

    const formDefinition = buildSchemaCompliantDefinition(
        schemaDefinitions,
        mailSenderFormDefinition
    );

    return [
        {
            fields: buildFormGridFields(schemaDefinitions, formDefinition),
            columnClass: "col-12"
        }
    ];
};
